// ============================================================
// Bouton « Publier sur git » des éditeurs de packs
// ============================================================
// Blocs, objets, entités, crafts (et recettes, drops), fichiers. Réservé à qui a le droit de publier
// (« Publications » en écriture, comme Envoyer) : pour les autres, le même bouton envoie une demande
// de publication, qu'un ayant droit valide. Le serveur revérifie le droit et, sans lui, ne pousse rien
// (PacksResource.publish). Fonction pure, testée par packPublishLabels.test.ts (node --test).

export interface PackPublishLabels {
  /** Libellé au repos. */
  idle: string;
  /** Libellé pendant l'envoi. */
  busy: string;
  /** Infobulle du bouton : seulement quand il envoie une demande (le bouton d'un ayant droit ne change pas). */
  title?: string;
}

export function packPublishLabels(canPublish: boolean): PackPublishLabels {
  return canPublish
    ? { idle: 'Publier sur git', busy: 'Publication…' }
    : {
        idle: 'Demander la publication',
        busy: 'Envoi de la demande…',
        title: "Tu n'as pas le droit de publier : une demande part, une personne qui a ce droit la validera",
      };
}
